import axios from 'axios';
import * as vars from './vars';

export function getSystemInformation (getSystemInformationRequest, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/GetSystemInfo',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : getSystemInformationRequest
    })
}

export function archiveSystemError (archiveSystemErrorRequest, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/ArchiveSystemError',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : archiveSystemErrorRequest
    })
}

